const { handleResponse, api, handleError } = require("./baseApi");
const api_config = require("./api_config");

const EXTEND_URL = "/purchases/v1/";
const REPORTS_URL = "/reports";

function makeStripePaymentApi(payment_data, locale) {
  return api
    .post(`${EXTEND_URL}quote${locale ? `?locale=${locale}` : ``}`, JSON.stringify(payment_data), {
      headers: { "x-api-key": `${api_config.carbon_app_api_key}` }
    })
    .then(handleResponse)
    .catch(handleError => {
      throw handleError.response && handleError.response.data
        ? handleError.response.data
        : handleError;
    });
}
function startOffSessionPaymentSetupApi(data) {
  return api
    .post(`${EXTEND_URL}off-session/start`, JSON.stringify(data), {
      headers: { "x-api-key": `${api_config.carbon_app_api_key}` }
    })
    .then(handleResponse)
    .catch(handleError => {
      throw handleError.response && handleError.response.data
        ? handleError.response.data
        : handleError;
    });
}

function makeGroupSubscriptionPaymentApi(data) {
  return api
    .post(`${EXTEND_URL}subscription/group`, JSON.stringify(data), {
      timeout: 60000,
      headers: { "x-api-key": `${api_config.carbon_app_api_key}` }
    })
    .then(handleResponse)
    .catch(handleError => {
      throw handleError.response && handleError.response.data
        ? handleError.response.data
        : handleError;
    });
}


function makeFootprintSubscriptionPaymentApi(data) {
  return api
    .post(`${EXTEND_URL}subscription/footprint`, JSON.stringify(data), {
      headers: { "x-api-key": `${api_config.carbon_app_api_key}` }
    })
    .then(handleResponse)
    .catch(handleError => {
      throw handleError.response && handleError.response.data
        ? handleError.response.data
        : handleError;
    });
}

function updateEmailPurchaseApi(email_data) {
  return api
    .patch(EXTEND_URL, JSON.stringify(email_data), {
      headers: { "x-api-key": `${api_config.carbon_app_api_key}` }
    })
    .then(handleResponse)
    .catch(handleError);
}

function getPurchasesByUserEmailApi(email, page = 1, size = 6) {
  const encodedEmail= encodeURIComponent(email);
  return api
  .get(`${EXTEND_URL}?email=${encodedEmail}&page=${page}&size=${size}`,
    {
    headers: { "x-api-key": `${api_config.carbon_app_api_key}` }
  })
  .then(handleResponse)
  .catch(handleError);
}

function getPurchasesByUserEmailReportsApi(email, page = 1, size = 6) {
  const encodedEmail= encodeURIComponent(email);
  return api
  .get(`${REPORTS_URL}${EXTEND_URL}?email=${encodedEmail}&page=${page}&size=${size}`,
    {
    headers: { "x-api-key": `${api_config.carbon_app_api_key}` }
  })
  .then(handleResponse)
  .catch(handleError);
}

function getPurchasesByMerchantCodeApi(merchantCode, page = 1, size = 6) {
  return api
  .get(`${EXTEND_URL}?merchantCode=${merchantCode}&page=${page}&size=${size}&ownershipType=MERCHANT`,
    {
    headers: { "x-api-key": `${api_config.carbon_app_api_key}` }
  })
  .then(handleResponse)
  .catch(handleError);
}

function getGroupSubscriptionPurchasesByMerchantCodeApi(merchantCode) {
  return api
    .get(`${EXTEND_URL}subscription/group?merchantCode=${merchantCode}`,
      {
        headers: { "x-api-key": `${api_config.carbon_app_api_key}` }
      })
    .then(handleResponse)
    .catch(handleError);
}

function getRecentPurchasesByUserEmailApi(email, maxAge = 60, size = 4) {
  const encodedEmail= encodeURIComponent(email);
  return api
    .get(`${EXTEND_URL}?email=${encodedEmail}&maxAge=${maxAge}&size=${size}`,
      {
        headers: { "x-api-key": `${api_config.carbon_app_api_key}` }
      })
    .then(handleResponse)
    .catch(handleError);
}

function getPurchaseByIdApi(id) {
  return api
    .get(`${EXTEND_URL}${id}`,
      {
        headers: { "x-api-key": `${api_config.carbon_app_api_key}` }
      })
    .then(handleResponse)
    .catch(handleError);
}

function getFlightsByEmailApi(email, pageNumber = 1, pageSize = 20) {
  const encodedEmail= encodeURIComponent(email);
  return api
    .get(`${EXTEND_URL}flights?email=${encodedEmail}&page=${pageNumber}&size=${pageSize}`,
      {
        headers: { "x-api-key": `${api_config.carbon_app_api_key}` }
      })
    .then(handleResponse)
    .catch(handleError);
}

function getFlightsByMerchantCode(merchantCode, size = 20, page = 1, customerEmailAddress) {
  return api
    .get(`${EXTEND_URL}flights?merchantCode=${merchantCode}&size=${size}&page=${page}&fields=${customerEmailAddress}`,
      {
        headers: { "x-api-key": `${api_config.carbon_app_api_key}` }
      })
    .then(handleResponse)
    .catch(handleError);
}

function getFlightReportByEmailApi(email) {
    const encodedEmail= encodeURIComponent(email);
    return api
        .get(`${EXTEND_URL}flights/summary?email=${encodedEmail}`,
            {
                headers: { "x-api-key": `${api_config.carbon_app_api_key}` }
            })
        .then(handleResponse)
        .catch(handleError);
}

function postPurchaseQuoteStartApi(quoteId) {
  return api
    .post(`${EXTEND_URL}quote/start`, JSON.stringify(quoteId),
      {
        headers: { "x-api-key": `${api_config.carbon_app_api_key}` }
      })
    .then(handleResponse)
    .catch(handleError);
}

module.exports = {
  makeStripePaymentApi,
  updateEmailPurchaseApi,
  getPurchasesByUserEmailApi,
  getPurchasesByMerchantCodeApi,
  getRecentPurchasesByUserEmailApi,
  getPurchaseByIdApi,
  getFlightsByEmailApi,
  getFlightReportByEmailApi,
  startOffSessionPaymentSetupApi,
  makeGroupSubscriptionPaymentApi,
  getGroupSubscriptionPurchasesByMerchantCodeApi,
  postPurchaseQuoteStartApi,
  makeFootprintSubscriptionPaymentApi,
  getFlightsByMerchantCode,
  getPurchasesByUserEmailReportsApi,
};
